module.exports = __webpack_public_path__ + "img/violet_095.86911109.png";